/* eslint-disable no-unused-vars */

import { trackAmplitude } from 'src/lib/analytics'

const viewAllClicked = (props) => {
  trackAmplitude(
    'Explore View',
    { ref: props.page, section: props.sectionId },
    props.viewer,
  )
}

export { viewAllClicked }
